/**
 *  Copyright (c) 2022-present TVM Engineering Authors.
 *
 */

import React from "react";

import {
  ContactSupportOutlined,
  AccountCircleOutlined,
  SupervisorAccount,
  Description,
  AttachFile,
  Input,
  // DownloadingIcon,
} from "@mui/icons-material";
import DownloadingIcon from "@mui/icons-material/Downloading";
import ConstructionIcon from "@mui/icons-material/Construction";
import NotificationsActiveIcon from "@mui/icons-material/NotificationsActive";
import RestoreIcon from "@mui/icons-material/Restore";
import { Menu, MenuItem, Divider } from "@mui/material";

import i18n from "../../services/i18n";
import STATIC_ROUTES from "../../route/STATIC_ROUTES";

interface Props {
  isAdminAccess?: boolean;
  open?: boolean;
  onClose: () => void;
  handleClick: () => void;
  anchorEl?: Object | null;
}

const MyAccountMenu = React.memo((props: Props) => {
  const { isAdminAccess } = props;

  return (
    <div className={classes.root}>
      <Menu
        id="headerMenuAppBar"
        anchorEl={props.anchorEl}
        sx={classes.alignMenu}
        open={props.open}
        onClose={props.onClose}
      >
        {isAdminAccess && (
          <MenuItem
            onClick={() => {
              props.handleClick(STATIC_ROUTES.admin, true);
            }}
          >
            <SupervisorAccount sx={classes.iconStyle} color="primary" /> {i18n.t("core:users")}
          </MenuItem>
        )}

        {isAdminAccess && (
          <MenuItem
            onClick={() => {
              props.handleClick(STATIC_ROUTES.terms, true);
            }}
          >
            <Description sx={classes.iconStyle} color="primary" /> {i18n.t("core:terms")}
          </MenuItem>
        )}

        {isAdminAccess && (
          <MenuItem
            onClick={() => {
              props.handleClick(STATIC_ROUTES.uploads, true);
            }}
          >
            <AttachFile sx={classes.iconStyle} color="primary" /> {i18n.t("core:uploads")}
          </MenuItem>
        )}
        {isAdminAccess && (
          <MenuItem
            onClick={() => {
              props.handleClick(STATIC_ROUTES.downloadHistory, true);
            }}
          >
            <DownloadingIcon sx={classes.iconStyle} color="primary" /> Download History
          </MenuItem>
        )}

        {isAdminAccess && (
          <MenuItem
            onClick={() => {
              props.handleClick(STATIC_ROUTES.maintenance, true);
            }}
          >
            <ConstructionIcon sx={classes.iconStyle} color="primary" /> Maintenance
          </MenuItem>
        )}
        {isAdminAccess && (
          <MenuItem
            onClick={() => {
              props.handleClick(STATIC_ROUTES.subscriptionHistory, true);
            }}
          >
            <NotificationsActiveIcon sx={classes.iconStyle} color="primary" /> Subscription History
          </MenuItem>
        )}
        {isAdminAccess && (
          <MenuItem
            onClick={() => {
              props.handleClick(STATIC_ROUTES.registrationHistory, true);
            }}
          >
            <RestoreIcon sx={classes.iconStyle} color="primary" /> Registration History
          </MenuItem>
        )}
        {isAdminAccess && <Divider />}

        <MenuItem
          onClick={() => {
            props.handleClick(STATIC_ROUTES.profile, true);
          }}
        >
          <AccountCircleOutlined sx={classes.iconStyle} color="primary" /> {i18n.t("core:account")}
        </MenuItem>
        <MenuItem
          onClick={() => {
            props.handleClick(STATIC_ROUTES.support, true);
          }}
        >
          <ContactSupportOutlined sx={classes.iconStyle} color="primary" />{" "}
          {i18n.t("core:supportMenuTitle")}
        </MenuItem>
        <MenuItem
          onClick={() => {
            props.handleClick(STATIC_ROUTES.logout, true);
          }}
        >
          <Input sx={classes.iconStyle} color="primary" /> {i18n.t("core:logout")}
        </MenuItem>
      </Menu>
    </div>
  );
});

export default MyAccountMenu;

const classes = {
  root: {
    overflowY: "hidden !important",
  },
  iconStyle: {
    marginRight: 2,
  },
  alignMenu: {
    marginTop: "45px",

    "& .MuiPaper-root": {
      top: "40px!important",
      overflowX: "unset!important",
      overflowY: "unset!important",

      "&:before": {
        content: "''",
        display: "inline-block",
        width: "25px",
        height: "25px",
        transform: "rotate(45deg)",
        boxShadow:
          "-3px -3px 3px -3px rgb(0 0 0 / 0%), -3px -3px 3px -3px rgb(0 0 0 / 2%), -3px -3px 3px -2px rgb(0 0 0 / 10%)",
        // width: '0',
        // height: '0',
        // borderLeft: '10px solid transparent',
        // borderRight: '10px solid transparent',
        // borderBottom: '25px solid #f0f0f0',
        position: "absolute",
        top: "-10px",
        left: "0px",
        right: "0px",
        margin: "0 auto",
        background: "#fff",
      },
    },
  },
};
